module.exports = __webpack_public_path__ + "static/media/digital_references.ec86a7c8.svg";